import React from 'react';
import { PageLayout } from './PageLayout';
import { LoadingScreen } from 'components/LoadingScreen/LoadingScreen';
import { useAppInitializer } from '../../../hooks/useAppInitializer';

export const TenantLayout: React.FC = () => {
  const { isLoading, user } = useAppInitializer();

  if (isLoading) {
    return <LoadingScreen />;
  }

  if (!user) {
    return null;
  }

  return <PageLayout />;
};